import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useCallback, forwardRef, memo } from "react";
;
const ContentScroll = memo(forwardRef(({ style, active, onScroll, ...props }, ref) => {
    const scrollTop = useRef(true);
    const handleScroll = useCallback((e) => {
        const target = e.currentTarget;
        scrollTop.current = target.scrollTop === 0;
        if (typeof onScroll === 'function') {
            onScroll(e);
        }
    }, []);
    const handleMove = useCallback((e) => {
        if (active && !scrollTop.current) {
            e.stopPropagation();
        }
    }, [scrollTop, active]);
    return (_jsx("div", { ...props, onTouchMove: handleMove, onScroll: handleScroll, style: { ...style, overflow: active ? 'auto' : 'hidden' }, ref: ref }));
}));
export { ContentScroll };
